import { useEffect } from 'react'

export const useReloadIfCached = () => {
  useEffect(() => {
    window.addEventListener('pageshow', e => {
      if (e.persisted) {
        window.location.reload()
      }
    })
  }, [])
}
